import illustration from '../../../../shared/assets/ppc-compliance-ignore-stub-illustration.svg'
import React from 'react'

export const TabIgnoreStub = () => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No data</h2>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'text-focus-500'}>
              Violators moved to &quot;Ignore&quot; won&apos;t appear in the main list, and you
              won&apos;t receive notifications about them
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
